module.exports = __webpack_public_path__ + "img/20_82.3fcc7fa2.png";